{
  "GOOGLE": "Se connecter avec Google",
  "FACEBOOK": "Se connecter avec Facebook",
  "LINKEDIN": "Se connecter avec LinkedIn",
  "google": "Continuer avec Google",
  "FACEBOOK_LOGIN": "Continuer avec Facebook",
  "LINKEDIN_LOGIN": "Continuer avec LinkedIn",
  "Email": "Continuer avec Email",
  "COMPLETED": "Terminé",
  "DECLINED": "Refusé",
  "EXPIRED": "Expiré",
  "IN_PROGRESS": "En cours",
  "SIGNED": "Signé",
  "REJECTED": "Rejeté",
  "DONE": "Fait",
  "CANCELLED": "Annulé",
  "COPIED": "Texte copié avec succès",
  "FAILED_TO_COPIED": "Échec de la copie du texte",
  "DISCARD": "Jeter",
  "BRANDING": "Marque",
  "SOON": "Bientôt",
  "PREVIEW": "Aperçu",
  "TITLE": "Titre",
  "FULL_NAME": "Nom complet",
  "PHONE": "Numéro de téléphone",
  "PREFERRED_LANGUAGE": "Langue du système",
  "SEARCH": "Recherche",
  "SELECT": "Sélectionner",
  "UPGRADE": "Mettre à niveau",
  "CONTACT_US": "Contactez-nous",
  "SIGNATURES": "Signatures",
  "PHONE_NUMBER": "Numéro de téléphone",
  "COUNTRY_CODE": "Indicatif du pays",
  "SELECTED": "Sélectionné",
  "UPDATE": "Enregistrer les modifications",
  "ACTIVE": "Actif",
  "PENDING": "En attente",
  "MONTH": "Mois",
  "YEAR": "Année",
  "OPEN_DROPDOWN_MENU": "Ouvrir le menu déroulant",
  "UNDO_CHANGES": "Annuler les modifications",
  "DISMISS": "Ignorer",
  "DATE": "Date",
  "DESCRIPTION": "Description",
  "ENGLISH": "Anglais",
  "ARABIC": "Arabe",
  "FRENCH": "Français",
  "DANISH": "Danois",
  "GENERAL": {
    "SERVICE_IN_MAINTENANCE": "Service en maintenance",
    "CANCEL": "Annuler",
    "EMAIL_ADDRESS": "Adresse e-mail",
    "EMAIL": "E-mail",
    "VOILA": "Voilà",
    "NO_CANCEL": "Non, Annuler",
    "YES_DELETE": "Oui, supprimer",
    "CONFIRM": "Oui, je suis sûr",
    "CONTINUE": "Continuer",
    "BACK": "Retour",
    "ERROR_MESSAGES": {
      "SOMETHING_WENT_WRONG": "Quelque chose s'est mal passé. Veuillez réessayer plus tard !",
      "NOT_FOUND": "Oups !!! Page non trouvée !",
      "SERVER_ERROR": "Erreur interne du serveur",
      "UNAUTHORIZED": "Non autorisé"
    }
  },
  "LANGUAGES": {
    "ENGLISH": "Anglais",
    "DANISH": "Danois",
    "ARABIC": "Arabe",
    "FRENCH": "Français"
  },
  "ORDER_STATUS_ICON": "icône d'état de la commande",
  "ORDER_ACTION_MENU": "menu d'actions de commande",
  "ORDER-STATISTICS": {
    "ALL-ORDER": "Toutes les commandes",
    "ACTIVE-ORDERS": "En cours",
    "COMPLETED-ORDERS": "Terminées",
    "CLOSED-ORDERS": "Clôturées"
  },
  "ORDER-DETAILS": {
    "ORDER-CANCELLED": {
      "SUCCESS": "Commande annulée avec succès",
      "ERROR": "Échec de l'annulation de la commande"
    },
    "ORDER-TITLE": "Titre de la commande",
    "RECIPIENTS": "Destinataires",
    "STATUS": "Statut",
    "SIGNING_STATUS": "Statut de signature",
    "LAST-CHANGE": "Activité",
    "EXPIRING-DATE": "Date d'expiration",
    "ACTIONS": "Actions",
    "ORDER-OPTIONS": {
      "SEND-REMINDER": "Envoyer un rappel",
      "ORDER-ACTIVITY": "Activité de la commande",
      "ORDER-DETAILS": "Détails de la commande",
      "CANCEL-ORDER": "Annuler la commande"
    },
    "CANCEL-ORDER-MODAL": {
      "TITLE": "Annuler cet ordre de signature ?",
      "SUBTITLE": "Tous les destinataires seront avertis.",
      "DESCRIPTION": "Tous les destinataires seront informés et ne pourront plus signer. Cette action est irréversible.",
      "CALLOUT": "Une fois annulé, ce document ne pourra pas être réactivé.",
      "KEEP-ORDER": "Non, garder l'ordre",
      "CANCEL-ORDER": "Annuler l'ordre"
    },
    "ORDER": "Commande",
    "TO": "À",
    "BY": "Par",
    "AT": "à",
    "MORE": "plus",
    "DONE": "fait",
    "ORDER-STATUS": "Statut de la commande",
    "SENT": "Envoyé",
    "EXPIRES": "Expire",
    "SIGNED-BY": "Signé par",
    "OF": "sur",
    "SIGNERS": "Signataires",
    "ORDER-ID": "N° de commande",
    "DAYS-REMAINING": "jours restants",
    "COMPLETION": "Complétion",
    "ATTACHMENTS": "Pièces jointes",
    "UPLOADED-BY": "Téléchargé par",
    "SIGNED-ON": "Signé le",
    "REJECTED-ON": "Rejeté le",
    "AUDIT-MOCK": "IP : — · OS : — · Navigateur : —",
    "ACTIVITY-LOG": "Journal d'activité",
    "RECEIVERS": "Destinataires",
    "REVIEWED-BY": "Révisé par",
    "REVIEWERS": "Réviseurs",
    "DOCUMENTS": "documents",
    "NO-SIGNERS": "Aucun signataire",
    "NO-RECEIVERS": "Aucun destinataire",
    "NO-REVIEWERS": "Aucun réviseur",
    "REMINDER-SENT": "Rappel envoyé",
    "RESEND-REMINDER": "Renvoyer le rappel",
    "CREATED-BY": "Créé par"
  },
  "PAGINATION": {
    "PREVIOUS": "Précédent",
    "NEXT": "Suivant",
    "PER_PAGE": "Par page",
    "SHOWING_RESULTS": "Affichage de {{from}}-{{to}} sur {{totalLength}} résultats"
  },
  "LANG": "Français",
  "PROCESSING": "traitement...",
  "SAVE": "Sauvegarder",
  "SAVE_DISCOUNT": "Sauvegarder",
  "SEND_ORDER": "Envoyer la commande",
  "DAY": "jour",
  "DAYS": "jours",
  "REVIEWER": "Besoin de révision",
  "SIGNER": "Besoin de signer",
  "COPIER": "Recevoir une copie",
  "SIDE_BAR": {
    "SIGNING": "Commandes de signature",
    "SETTINGS": "Paramètres",
    "FAQ": "FAQ",
    "FORMS": "Formulaires",
    "LOG_OUT": "Se déconnecter",
    "PROFILE": "Profil"
  },
  "HEADER": {
    "CREATE_ORDER": "Créer une commande",
    "MANAGE_ORDER": "Commandes de signature"
  },
  "CONTRACT_ORDER": {
    "RECIPIENT_INFORMATION": "Informations sur le destinataire",
    "ORDER_SETTINGS": "Paramètres de la commande",
    "ORDER_MESSAGE": "Message de la commande",
    "NEW_SIGNING_ORDER": "Nouvelle commande de signature",
    "ORDER_TITLE": "Titre de la commande",
    "REMIND_SIGNERS": "Rappeler aux signataires tous les",
    "EMAIL_SUBJECT": "Objet de l’e-mail",
    "EMAIL_SUBJECT_PLACEHOLDER": "[Nom de l’expéditeur] vous a envoyé des documents à signer",
    "EMAIL_BODY": "Message",
    "EMAIL_BODY_PLACEHOLDER": "Ajoutez un court message à vos destinataires (facultatif). Il apparaîtra dans l’e-mail contenant le lien de signature.",
    "NAME": "Nom",
    "EMAIL": "E-mail",
    "PHONE_NUMBER": "Numéro de téléphone",
    "TASK": "Tâche",
    "ADD_RECIPIENT": "Ajouter un destinataire",
    "ACTIONS": "Actions",
    "PRIORITY": "Priorité",
    "MESSAGE-ALL": "Message pour tous",
    "SELECT-TASK": "Sélectionner une tâche",
    "SELECT-PRIORITY": "Sélectionner une priorité",
    "ENTER-EMAIL": "Entrer l'adresse e-mail",
    "ENTER-NAME": "Entrer votre nom",
    "ENTER-PHONE": "Entrer le numéro de téléphone",
    "MOVE_DOWN": "Déplacer vers le bas",
    "MOVE_UP": "Déplacer vers le haut",
    "DELETE": "Supprimer",
    "RECEIVE": "Recevoir",
    "ROLE": "Rôle",
    "REVIEW_DOCUMENT": "Réviser le document",
    "SIGN_DOCUMENT": "Signer le document",
    "MOVE_TO": "Déplacer vers",
    "NO_RECIPIENTS": "Aucun destinataire ajouté pour l'instant",
    "RECEIVE_NEXT": "Recevoir le suivant",
    "REMIND_PERIOD": "Rappeler le destinataire tous les",
    "EXPIRATION_PERIOD": "Période d'expiration",
    "LOGIN_TO_VIEW_DOCUMENTS": "Connexion requise pour voir les documents",
    "RECEIVE_COPY": "Recevoir une copie",
    "NEXT": "Suivant",
    "SEND_ORDER": "Envoyer la commande",
    "SIGNING_METHOD": "Méthode de signature (facultatif)",
    "REMINDERS_SENT_SUCCESSFULLY": "Påmindelser er sendt",
    "ORDER_WAS_CANCELLED_OR_DECLINED": "La commande a été annulée ou refusée!",
    "OUT_OF_SIGNATURES_WARNING": "Plus de signatures disponibles.",
    "EXTRA_SIGNATURES_ARE_NEEDED": "Cette commande ne peut pas être finalisée en raison de signatures insuffisantes.",
    "CANT_ADD_RECIPIENTS": "Vous ne pouvez pas ajouter plus de destinataires en raison de signatures insuffisantes.",
    "VERIFICATION_METHOD": "Méthode de vérification",
    "WHATSAPP": "Whatsapp",
    "DISCARD_ORDER_TITLE": "Confirmer l'annulation de la commande",
    "DISCARD_ORDER_SUBTITLE": "Cette action est irréversible.",
    "DISCARD_ORDER_DESCRIPTION": "Êtes-vous sûr de vouloir annuler cette commande?",
    "KEEP_EDITING": "Continuer à éditer",
    "DISCARD_ORDER": "Annuler la commande",
    "NOT_SPECIFIED": "Non défini",
    "NEW_SIGNING_ORDER_SUBTITLE": "Ajoutez vos documents, choisissez qui signe et dans quel ordre, puis envoyez-les.",
    "ORDER_LANGUAGE": "Langue de la commande",
    "RECIPIENT_DETAILS": "Détails du destinataire",
    "RECEIVER_DETAILS": "Détails du destinataire",
    "NO_RECEIVERS_YET": "Aucun destinataire ajouté pour l'instant",
    "ADD_RECEIVER": "Ajouter un destinataire",
    "RECIPIENTS_LABEL": "destinataires",
    "RECEIVERS_LABEL": "destinataires",
    "ORDINAL_RECIPIENTS": [
      "Premier destinataire",
      "Deuxième destinataire",
      "Troisième destinataire",
      "Quatrième destinataire",
      "Cinquième destinataire",
      "Sixième destinataire",
      "Septième destinataire",
      "Huitième destinataire",
      "Neuvième destinataire",
      "Dixième destinataire"
    ]
  },
  "SETTINGS": {
    "NAME": "Paramètres",
    "ACCOUNT_INFO": "Informations sur le compte",
    "CHANGE_PASSWORD": "Changer le mot de passe",
    "CHANGE_PASSWORD_EMAIL_SENT": "Un e-mail de réinitialisation du mot de passe a été envoyé à votre boîte de réception",
    "CHANGE_PASSWORD_EMAIL_FAILED": "Échec de l'envoi de l'e-mail de réinitialisation, veuillez réessayer",
    "TEAM_MANAGEMENT": "Gestion des utilisateurs",
    "TEAM_MANAGEMENT_DESCRIPTION": "Gérez les membres de votre équipe et leurs autorisations d’accès.",
    "ORDER_SETTINGS": "Paramètres de la commande",
    "FIRST_NAME": "Prénom",
    "LAST_NAME": "Nom de famille",
    "ROLE": "Rôle",
    "INVITATION_STATUS": "Statut de l'invitation",
    "INVITE_SUCCESS": "Utilisateur invité avec succès",
    "INVITE_ERROR": "Erreur lors de l'invitation de l'utilisateur",
    "INVITE_MEMBERS_ERROR": "Impossible d'envoyer les invitations. Réessayez depuis les Paramètres.",
    "SEND_INVITATION": "Envoyer une invitation",
    "MANAGE_SUBSCRIPTION": "Gestion des abonnements",
    "SUBSCRIPTIONS": "Abonnements",
    "CHANGE_PLAN": "Modifier le forfait d’abonnement",
    "MANAGE_PAYMENTS": "Gérer les paiements",
    "CHANGE_PLAN_QUESTION": "Changer de plan ?",
    "CANCEL_SUBSCRIPTION": "Annuler l'abonnement",
    "DELETE_TEAM_MEMBER": "Supprimer un membre de l'équipe",
    "DELETE_TEAM_MEMBER_DESCRIPTION": "Vous êtes sur le point de supprimer \"<span class='font-bold'>{{name}}</span>\" de l'équipe. Leurs <span class='font-bold'>{{ordersCount}}</span> commandes actives seront réattribuées à un autre membre.",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_NAME": "Vous êtes sur le point de supprimer \"<span class='font-bold'>{{email}}</span>\" de l'équipe. Leurs <span class='font-bold'>{{ordersCount}}</span> commandes actives seront réattribuées à un autre membre.",
    "PLAN_NAME": "<span class='font-bold'>Forfait :</span> <span class='font-medium'>{{planName}}</span>",
    "SUBSCRIPTION_MANAGEMENT": "Abonnement",
    "SUBSCRIPTION_MANAGEMENT_DESCRIPTION": "Surveillez votre utilisation et gérez les détails de votre plan d'abonnement.",
    "TRANSACTION_HISTORY": "Historique de facturation",
    "SIGNATURES_USED_OF": "sur {{signatures}} signatures utilisées",
    "SIGNATURES_USED_TOTAL": "{{used}} sur {{total}} utilisées",
    "SIGNATURE_USAGE": "Utilisation des signatures",
    "AUTO_RENEWAL": "Renouvellement automatique",
    "SUBSCRIPTIONS_TITLE": "Ajouter des signatures",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_ORDER": "Vous êtes sur le point de supprimer \"<span class='font-bold'>{{name}}</span>\" de l'équipe.",
    "DELETE_TEAM_MEMBER_DESCRIPTION_NO_ORDER_NO_NAME": "Vous êtes sur le point de supprimer \"<span class='font-bold'>{{email}}</span>\" de l'équipe.",
    "REASSIGN_BEFORE_REMOVING": "Réattribuez leur travail avant de les supprimer.",
    "REASSIGN_ORDERS_TO": "Réattribuer les commandes à",
    "INVITE_TEAM_MEMBER": "Ajouter un coéquipier",
    "INVITE_TEAM_MEMBER_TITLE": "Inviter un membre de l'équipe",
    "INVITE_TEAM_MEMBER_SUBTITLE": "Ajoutez un nouveau membre à votre espace de travail.",
    "MEMBER_INVITATION_NOTE": "Chaque membre recevra un e-mail d'invitation pour créer son compte.",
    "ACCEPT_TERMS_AND_CONDITIONS": "J'accepte les conditions d'utilisation et la politique de confidentialité",
    "USER_DELETED_SUCCESSFULLY": "Utilisateur supprimé avec succès",
    "FAILED_TO_DELETE_USER": "Échec de la suppression de l'utilisateur",
    "ACCOUNT_SETTINGS_UPDATED_SUCCESSFULLY": "Paramètres du compte mis à jour avec succès",
    "FAILED_TO_UPDATE_ACCOUNT_SETTINGS": "Échec de la mise à jour des paramètres du compte",
    "PUBLIC_PROFILE": "Compte",
    "PUBLIC_PROFILE_SUBTITLE": "Vos informations personnelles, votre langue et votre mot de passe.",
    "PROFILE_PICTURE": "Photo de profil",
    "UPLOAD_NEW_PHOTO": "Télécharger une nouvelle photo",
    "PHOTO_HINT": "JPG ou PNG. Taille max. {{maxSizeMb}} Mo",
    "PREFERENCES": "Préférences",
    "PREFERENCES_SUBTITLE": "Choisissez la langue d’affichage de JunoSign.",
    "ACCOUNT_SECURITY": "Sécurité du compte",
    "ACCOUNT_SECURITY_SUBTITLE": "Gérez votre mot de passe et vos paramètres d'authentification.",
    "CHOOSE_A_PLAN": "Mettez à niveau votre forfait pour vos nouveaux besoins professionnels.",
    "CHOOSE_A_PLAN_DESCRIPTION": "Chez JunoSign, nous nous concentrons sur les marchés où la technologie, l'innovation et le capital peuvent générer une valeur à long terme et stimuler la croissance économique.",
    "PER_USER_MONTHLY": "Par utilisateur/mois",
    "PER_USER_YEARLY": "Par utilisateur/an",
    "CHANGE_PLAN_CONFIRMATION": "Êtes-vous sûr de vouloir changer votre plan pour {{planName}}/{{period}} ?",
    "CHANGE_PLAN_SUCCESS_MESSAGE": "Le changement de plan est prévu pour la prochaine date de facturation",
    "SCHEDULED_PLAN_MESSAGE": "Votre forfait passe au <span class='font-bold'>forfait {{planName}}</span> le {{date}}",
    "SCHEDULED_CHANGES_CANCEL_SUCCESS": "Les modifications planifiées de votre forfait ont été annulées",
    "CANCEL_SUBSCRIPTION_CHANGES": "Annuler les modifications de l’abonnement",
    "CANCEL_SUBSCRIPTION_CHANGES_SUBTITLE": "Revenir aux paramètres de votre plan actuel",
    "CANCEL_SUBSCRIPTION_CHANGES_DESCRIPTION": "Annuler le passage à l’abonnement {{planName}} ?",
    "CANCEL_SUBSCRIPTION_CHANGES_SECONDARY_DESCRIPTION": "Votre plan actuel restera actif.",
    "CANCEL_SUBSCRIPTION_SUBTITLE": "Cette action est irréversible.",
    "CANCEL_SUBSCRIPTION_CONFIRMATION": "L’annulation de votre abonnement supprimera votre accès, et vous ne serez pas facturé lors du prochain cycle de facturation.",
    "CANCEL_SUBSCRIPTION_CONFIRMATION_END_DATE": "Votre abonnement actuel restera actif jusqu’au {{endDate}}.",
    "CANCEL_SUBSCRIPTION_SUCCESS": "Votre abonnement a été programmé pour annulation",
    "CANCEL_SUBSCRIPTION_MESSAGE": "Votre forfait est prévu pour être annulé le {{date}}",
    "REMOVE_CANCELLATION": "Annuler L’annulation",
    "REMOVE_CANCELLATION_SUBTITLE": "Votre abonnement restera actif.",
    "REMOVE_CANCELLATION_DESCRIPTION": "Annuler l’annulation de votre abonnement ?",
    "REMOVE_CANCELLATION_BILLING_DATE": "Votre abonnement restera actif et vous serez facturé le {{date}}",
    "REMOVE_CANCELLATION_SUCCESS": "L’annulation planifiée de votre abonnement a été supprimée",
    "ROLE_UPDATED_SUCCESSFULLY": "Le rôle de l'utilisateur a été mis à jour avec succès",
    "API_SETTINGS": {
      "TITLE": "Paramètres API",
      "DESCRIPTION": "Générez des clés API et gérez vos identifiants pour intégrer des systèmes externes en toute sécurité.",
      "EMPTY_TITLE": "Aucune clé API pour le moment",
      "EMPTY_DESCRIPTION": "Créez votre première clé API pour intégrer des services externes et automatiser votre flux de signature.",
      "CREATE_API_KEY": "Créer une clé API",
      "CREATE_MODAL_SUBTITLE": "Générez une nouvelle clé API pour votre espace de travail.",
      "EDIT_API_KEY": "Modifier la clé API",
      "EDIT_MODAL_SUBTITLE": "Mettez à jour le nom et les permissions de votre clé API.",
      "KEY_NAME": "Nom de la clé",
      "KEY_NAME_HINT": "Le nom par défaut est celui de votre espace de travail",
      "EXPIRATION_DATE": "Date d'expiration",
      "EXPIRATION_DAYS": "{{days}} jours",
      "PERMISSIONS": "Permissions",
      "PERMISSION": {
        "CREATE": "Créer",
        "READ": "Lire",
        "UPDATE": "Mettre à jour",
        "DELETE": "Supprimer"
      },
      "PERMISSION_REQUIRED": "Sélectionnez au moins une permission.",
      "CREATE": "Créer",
      "SAVE": "Enregistrer",
      "DONE": "Terminé",
      "COPY": "Copier {{field}}",
      "CREATED_TITLE": "Clé API créée avec succès",
      "CREATED_SUBTITLE": "Vos nouveaux identifiants sont prêts à être utilisés.",
      "ROTATED_TITLE": "Clé API renouvelée avec succès",
      "ROTATED_SUBTITLE": "Vos nouveaux identifiants sont prêts à être utilisés.",
      "CLIENT_ID": "Identifiant client",
      "SECRET_KEY": "Clé secrète",
      "SAVE_SECRET_WARNING": "Enregistrez votre clé secrète maintenant. Vous ne pourrez plus la voir.",
      "STATUS": {
        "ACTIVE": "Active",
        "DISABLED": "Désactivée"
      },
      "CREATED": "Créée le",
      "LAST_USED": "Dernière utilisation",
      "NEVER_USED": "Jamais",
      "DATE_AT_TIME": "{{date}} à {{time}}",
      "EXPIRES_ON": "{{date}} ({{days}} jours)",
      "DISABLE": "Désactiver",
      "ENABLE": "Activer",
      "ROTATE": "Renouveler",
      "MENU": {
        "ROTATE": "Renouveler la clé API",
        "EDIT": "Modifier la clé API",
        "DELETE": "Supprimer la clé"
      },
      "DISABLED_BANNER": "Cette clé API est actuellement désactivée. Activez-la pour rétablir l'accès.",
      "ROTATE_MODAL": {
        "TITLE": "Renouveler la clé API",
        "SUBTITLE": "Votre clé actuelle sera révoquée.",
        "MESSAGE": "Une nouvelle clé secrète sera générée avec les mêmes permissions. La clé actuelle sera immédiatement révoquée et toutes les intégrations qui l'utilisent cesseront de fonctionner.",
        "CALLOUT": "Le renouvellement est définitif. Enregistrez votre nouvelle clé maintenant.",
        "CONFIRM": "Renouveler la clé"
      },
      "DISABLE_MODAL": {
        "TITLE": "Désactiver la clé API",
        "SUBTITLE": "Cette clé cessera de fonctionner immédiatement.",
        "MESSAGE": "Toutes les intégrations utilisant cette clé perdront immédiatement l'accès à l'API et cesseront de fonctionner. Vous pouvez réactiver cette clé à tout moment pour rétablir l'accès.",
        "CALLOUT": "Vous pouvez réactiver cette clé à tout moment.",
        "CONFIRM": "Désactiver la clé"
      },
      "ACTIVATE_MODAL": {
        "TITLE": "Activer la clé API",
        "SUBTITLE": "Cette clé fonctionnera immédiatement.",
        "MESSAGE": "Toutes les intégrations configurées avec cette clé retrouveront l'accès à l'API. Assurez-vous que vos services sont prêts à traiter les requêtes.",
        "CALLOUT": "Une fois activée, cette clé sera immédiatement opérationnelle.",
        "CONFIRM": "Activer la clé"
      },
      "DELETE_MODAL": {
        "TITLE": "Supprimer la clé API",
        "SUBTITLE": "Cette action est irréversible.",
        "MESSAGE": "La clé API sélectionnée et toutes les permissions associées seront définitivement supprimées. Toute intégration ou tout service actif dépendant de cette clé échouera instantanément.",
        "CALLOUT": "Cette action est irréversible. Assurez-vous qu'aucun service ne dépend de cette clé.",
        "CONFIRM": "Supprimer la clé"
      },
      "UPDATED_SUCCESSFULLY": "Clé API mise à jour avec succès",
      "DISABLED_SUCCESSFULLY": "Clé API désactivée avec succès",
      "ENABLED_SUCCESSFULLY": "Clé API activée avec succès",
      "DELETED_SUCCESSFULLY": "Clé API supprimée avec succès",
      "SCOPES": "Portées",
      "SCOPE": {
        "ORDERS_READ": "Lire",
        "ORDERS_CREATE": "Créer",
        "ORDERS_CANCEL": "Supprimer",
        "WEBHOOKS_MANAGE": "Permission Webhooks"
      },
      "EXPIRY": {
        "ONE_MONTH": "30 jours",
        "THREE_MONTHS": "90 jours",
        "SIX_MONTHS": "180 jours",
        "ONE_YEAR": "1 an"
      }
    }
  },
  "TRANSACTION_HISTORY": {
    "PAYMENT_ID": "N° de transaction",
    "TRANSACTION_DATE": "Date de la transaction",
    "DOWNLOAD_INVOICE": "Télécharger",
    "NO_HISTORY": "Aucun historique de facturation pour l'instant",
    "NO_HISTORY_DESCRIPTION": "Vos transactions de facturation et vos factures apparaîtront ici dès que vous aurez effectué votre premier paiement."
  },
  "DATE_RANGE": {
    "ALL_TIME": "Tout le temps",
    "LAST_YEAR": "L'année dernière",
    "LAST_MONTH": "Le mois dernier",
    "LAST_7_DAYS": "Les 7 derniers jours",
    "CURRENT_MONTH": "Mois en cours"
  },
  "FILE": {
    "DROP_FILE": "Déposez des fichiers ou",
    "UPLOAD_DOCUMENTS": "Téléchargez des documents ici",
    "BROWSE": "parcourir",
    "SUPPORTED_FORMAT": "Formats pris en charge : JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word, PPT",
    "SUPPORTED_FORMAT_PDF": "Formats pris en charge : PDF",
    "TITLE": "Titre du fichier",
    "TYPE": "Type",
    "ATTACHMENT": "PIÈCE JOINTE",
    "TO_SIGN": "À signer",
    "DUPLICATE_ERROR_MESSAGE": "Le fichier existe déjà",
    "DOCUMENTS": "Documents",
    "NO_DOCUMENTS": "Aucun document ajouté pour l'instant",
    "RENAME_TITLE": "Renommer le fichier en double",
    "RENAME_SUBTITLE": "Choisissez un nouveau nom pour chaque doublon",
    "SIZE_KB": "Ko",
    "SIZE_MB": "Mo"
  },
  "VALIDATION_MESSAGES": {
    "ONE_RECIPIENT": "Ajouter au moins un destinataire",
    "ONE_FILE": "Ajouter au moins un fichier",
    "IS_REQUIRED": "est requis",
    "CONTRACT_CREATED": "Commande de contrat créée avec succès",
    "CONTRACT_SIGNED": "Commande de contrat signée avec succès",
    "REQUIRED": "Ce champ est requis",
    "PHONE_INVALID": "Veuillez entrer un numéro de téléphone valide",
    "NAME_INVALID": "Le nom est requis",
    "EMAIL_INVALID": "Veuillez entrer un e-mail valide",
    "EMAIL_REQUIRED": "L'e-mail est requis",
    "EMAIL_EXISTS": "L'e-mail existe déjà",
    "MINIMUM_AGE": "Votre âge est de {{age}} ans, vous devez avoir au moins {{minAge}} ans",
    "MAXIMUM_AGE": "Votre âge est de {{age}} ans, vous devez avoir au plus {{maxAge}} ans",
    "MINIMUM_LENGTH": "Il doit comporter au moins {{length}} caractères",
    "MAXIMUM_LENGTH": "Il doit comporter au plus {{length}} caractères",
    "PASSWORD_MISMATCH": "Votre mot de passe ne correspond pas",
    "LENGTH_INPUT": "La valeur que vous avez entrée fait {{length}} caractères",
    "NOT_EMPTY": "Ce champ ne peut pas être vide",
    "DUPLICATE_EMAIL": "Les e-mails en double ne sont pas autorisés",
    "DOCUMENT_REQUIRED": "Au moins un document doit être fourni",
    "INVALID_PHONE_NUMBER": "Numéro de téléphone invalide",
    "MISSING_DATA": "Veuillez remplir les champs requis"
  },
  "ORDER_ACTIVITY": {
    "ORDER_ACTIVITY": "Activité de commande",
    "TIME": "Temps",
    "RECIPIENT": "Destinataire",
    "ACTION": "Action",
    "ACTIVITY": "Activité",
    "STATUS": "Statut",
    "DATA_LOADING": "Chargement des données",
    "NO_DATA_FOUNDED": "Aucune donnée trouvée"
  },
  "ERRORS": {
    "NOT_FOUND": "Page non trouvée",
    "FORBIDDEN": "Vous n'avez pas la permission d'accéder à cette page",
    "FILE_NOT_SUPPORTED": "L'extension de fichier n'est pas prise en charge",
    "SERVER_ERROR": "Quelque chose s'est mal passé. Veuillez réessayer.",
    "UNKNOWN_ERROR": "Une erreur inconnue s'est produite, veuillez contacter le support."
  },
  "LOGIN": {
    "MESSAGE": "Connectez-vous à DSS",
    "LOGIN-ERROR": "Erreur de connexion. Veuillez réessayer",
    "UNAUTHORIZED": "Non autorisé à signer avec cet e-mail",
    "WELCOME_BACK": "Bon retour !",
    "WELCOME": "Bienvenue",
    "LOGIN_AGAIN": "Veuillez vous connecter pour accéder au système",
    "TRY_AGAIN": "Veuillez réessayer"
  },
  "CREATE_CLIENT": {
    "DSS": "DSS",
    "HEADING": "Collaboration contractuelle à chaque étape du cycle de vie",
    "NOTE": "*Dites-nous qui est votre employeur actuel"
  },
  "CREATE_ORGANIZATION": {
    "HEADING": "Créons votre organisation",
    "SUBHEADING": "L'organisation est le conteneur pour vos commandes ou documents.",
    "ORGANIZATION_NAME": "Nom de l'organisation",
    "FORM_EYEBROW": "CONFIGURATION DE L'ORGANISATION",
    "FORM_HEADING": "Nommez votre organisation",
    "FORM_SUBHEADING": "C’est là que les documents de votre équipe seront centralisés. Vous inviterez vos collègues à l’étape suivante.",
    "ORGANIZATION_NAME_PLACEHOLDER": "ex. JunoSign Inc.",
    "FIELD_HINT": "Ce nom apparaît sur chaque document et invitation envoyés depuis votre organisation.",
    "NAME_MAX_LENGTH_ERROR": "Le nom de l'organisation ne peut pas dépasser 50 caractères.",
    "CREATE_ERROR": "Une erreur est survenue lors de la création de votre organisation. Veuillez réessayer.",
    "SUBMIT_BUTTON": "Créer l'organisation",
    "BACK_LINK": "Retour",
    "STEP_BADGE": "Étape 3 sur 4 — Configuration de l'organisation",
    "HERO_HEADLINE_1": "Un espace pour",
    "HERO_HEADLINE_2": "chaque ",
    "HERO_HEADLINE_ITALIC": "signature.",
    "HERO_TEXT_1": "Un seul endroit pour chaque document, signataire et piste d’audit créés par votre équipe. Configurez-le une seule fois.",
    "BENEFIT_1_TITLE": "Valable juridiquement au Moyen-Orient et en Europe",
    "BENEFIT_1_DESC": "eIDAS QES, SOC 2 II, SSL — vos signatures tiennent là où c'est important.",
    "BENEFIT_2_TITLE": "Envoyez votre premier doc en 90 secondes",
    "BENEFIT_2_DESC": "Glissez, déposez, envoyez. Modèles réutilisables pour les contrats hebdomadaires.",
    "BENEFIT_3_TITLE": "Conçu pour les équipes, au juste prix",
    "BENEFIT_3_DESC": "Rôles, journaux d'audit, SSO. Facturation par siège — sans frais surprises.",
    "STAT_SIGN_TIME_LABEL": "Temps moyen de signature",
    "STAT_UPTIME_LABEL": "SLA de disponibilité",
    "STAT_TEAMS_LABEL": "Équipes actives"
  },
  "INVITE_MEMBERS": {
    "CALLABORATE_WITH_YOUR_TEAM": "Collaborez avec votre équipe",
    "INVITE_YOUR_TEAMMATES": "Invitez vos coéquipiers",
    "ADD_ANOTHER": "Ajoutez-en un autre",
    "BUTTON_FINISH": "Terminer",
    "BUTTON_SKIP": "Passer pour l’instant",
    "BUTTON_BACK": "Retour",
    "CHARGED_PER_INVITE": "Les frais d’abonnement de chaque membre de l’équipe seront facturés séparément après l’acceptation de l’invitation et leur première connexion.",
    "FORM_EYEBROW": "FACULTATIF - VOUS POUVEZ PASSER",
    "FORM_SUBHEADING": "Ajoutez des coéquipiers à votre organisation. Chacun recevra une invitation par e-mail pour la rejoindre.",
    "EMAIL_PLACEHOLDER": "nom@entreprise.fr",
    "BILLING_NOTE": "Chaque coéquipier utilise un siège, facturé mensuellement. Vous pouvez ajouter ou supprimer des sièges à tout moment dans les Paramètres.",
    "SEND_INVITES": "Envoyer les invitations",
    "STEP_BADGE": "Étape 4 sur 4 — Inviter l'équipe",
    "HERO_HEADLINE_1": "La signature fonctionne",
    "HERO_HEADLINE_2": "mieux",
    "HERO_HEADLINE_3": "en équipe.",
    "HERO_TEXT_1": "Ajoutez des coéquipiers par e-mail et définissez leur rôle. Ils pourront préparer, envoyer et suivre les documents dès qu’ils accepteront l’invitation.",
    "BENEFIT_1_TITLE": "Valable juridiquement au Moyen-Orient et en Europe",
    "BENEFIT_1_DESC": "Les signatures sont valables en vertu de la loi égyptienne n° 15 de 2004, réglementée par l’ITIDA, et dans toute l’Europe au titre d’eIDAS.",
    "BENEFIT_2_TITLE": "Envoyez votre premier doc en 90 secondes",
    "BENEFIT_2_DESC": "Glissez, déposez, envoyez. Modèles réutilisables pour les contrats hebdomadaires.",
    "BENEFIT_3_TITLE": "Conçu pour les équipes, au juste prix",
    "BENEFIT_3_DESC": "Rôles, journaux d'audit, SSO. Facturation par siège — sans frais surprises."
  },
  "PAYMENT": {
    "YEARLY_PLAN": "Plan annuel",
    "MONTHLY_PLAN": "Plan mensuel",
    "SUBSCRIPTION_MODAL_TITLE": "Choisissez le bon plan pour votre entreprise",
    "SUBSCRIPTION_MODAL_DESCRIPTION": "Ici chez JunoSign, nous nous concentrons sur les marchés où la technologie, l'innovation et le capital peuvent débloquer une valeur à long terme et stimuler la croissance économique.",
    "MONTHLY": "Mensuel",
    "YEARLY": "Annuel",
    "CHOOSE_PLAN": "Choisir un plan",
    "TERMS_AND_CONDITIONS": "Termes et Conditions",
    "LIMITED_LINKS": "Tous les liens limités",
    "ANALYTICS_PLATFORM": "Plateforme d'analyse",
    "CHAT_SUPPORT": "Assistance par chat",
    "OPTIMIZE_HASHTAGS": "Optimiser les hashtags",
    "UNLIMITED_USERS": "Utilisateurs illimités"
  },
  "FORMS": {
    "FORM_INFORMATION": "Informations sur le formulaire",
    "TRUCK": "Camion",
    "LICENSE": "Licence",
    "TRADER_NAME": "Nom du trader",
    "TRADER_EMAIL": "E-mail du trader",
    "TRADER_PHONE": "Téléphone du trader",
    "FORM_DETAILS": "Détails du formulaire",
    "ITEMS": "Articles",
    "QUANTITY": "Qté",
    "PRICE": "Prix",
    "TOTAL": "Total",
    "ITEM_NAME": "Nom de l'article",
    "APPLES": "Pommes",
    "BANANAS": "Bananes",
    "WATERMELONS": "Pastèques",
    "ORANGES": "Oranges",
    "GRAPES": "Raisins",
    "SUBMIT": "Soumettre",
    "ITEM_REQUIRED": "L'article est requis",
    "FORMS": "Formulaires",
    "CREATE_FORM": "Créer un formulaire",
    "FORM_ID": "ID du formulaire",
    "FORM_NAME": "Nom du formulaire",
    "CREATED_AT": "Créé à",
    "LINK": "Lien",
    "DELETE": "Supprimer",
    "LATEST_SUBMISSION": "Dernière soumission",
    "FORM_CREATED_SUCCESSFULLY": "Formulaire créé avec succès",
    "FAILED_TO_CREATE_FORM": "Échec de la création du formulaire",
    "SETTINGS": {
      "FORM_SETTINGS": "Paramètres du formulaire",
      "SIGNER_SETTINGS": "Paramètres du signataire",
      "NOTIFICATIONS": "Notifications",
      "BASIC_INFORMATION": {
        "TITLE": "Informations de base",
        "FORM_NAME": "Nom du formulaire",
        "LANGUAGE": "Langue",
        "REPLY_TO_NAME": "Nom pour répondre",
        "REPLY_TO_EMAIL": "E-mail pour répondre"
      }
    }
  },
  "ORGANIZATIONS": {
    "SWITCH_ORGANIZATION": "Changer d'organisation",
    "SELECT_WORKSPACE": "Sélectionnez l'espace de travail vers lequel basculer",
    "SWITCH": "Changer",
    "CURRENT": "Actuel",
    "NEW_ORGANIZATION": "Nouvelle organisation ?",
    "CREATE_NOW": "Créer maintenant",
    "MEMBERS": "membres"
  },
  "TERMS_AND_CONDITIONS": {
    "FIRST": "Acceptation des termes",
    "FIRSTDESCRIPTION": "En utilisant DSS, vous acceptez d'être lié par ces termes et conditions. Si vous n'acceptez pas ces termes et conditions, veuillez ne pas utiliser DSS.",
    "SECOND": "Modification des termes et conditions",
    "SECONDDESCRIPTION": "DSS se réserve le droit de modifier, d'amender ou de mettre à jour ces termes et conditions à sa seule discrétion. Toute modification des termes sera effective immédiatement après la publication de la version révisée sur le site Web de DSS. Il est de votre responsabilité de consulter régulièrement les termes pour rester informé des modifications. L'utilisation continue de DSS après la publication des modifications constitue votre acceptation des termes et conditions mis à jour. Si vous n'acceptez pas les modifications, veuillez vous abstenir d'utiliser DSS et nous contacter à [Vos coordonnées] pour toute préoccupation.",
    "THIRD": "Services fournis par DSS",
    "THIRDDESCRIPTION": "Une solution de signature électronique qui permet aux utilisateurs de signer et d'envoyer des documents électroniquement. DSS est un service basé sur le cloud accessible depuis tout appareil connecté à Internet.",
    "FOURTH": "Comptes utilisateurs pour utiliser DSS",
    "FOURTHDESCRIPTION": "vous devez créer un compte utilisateur. Lorsque vous créez un compte, vous devrez fournir certaines informations, y compris votre nom, votre adresse e-mail et votre mot de passe. Vous êtes responsable de la confidentialité des informations de votre compte.",
    "FIFTH": "Utilisation des services",
    "FIFTHDESCRIPTION": "Vous pouvez utiliser DSS pour signer et envoyer des documents à des fins personnelles ou professionnelles. Vous ne pouvez pas utiliser DSS pour signer ou envoyer des documents illégaux, nuisibles ou diffamatoires.",
    "SIXTH": "Propriété intellectuelle",
    "SIXTHDESCRIPTION": "DSS et tout son contenu, y compris mais sans s'y limiter, le logiciel, le texte, les images et les graphiques, sont la propriété de DSS. Vous ne pouvez pas copier, modifier, distribuer ou vendre une partie de DSS sans notre autorisation écrite.",
    "SEVENTH": "Protection des données",
    "SEVENTHDESCRIPTION": "Chez DSS, la protection de vos données est notre engagement primordial. Nous adhérons à des normes de confidentialité strictes pour garantir la confidentialité et la sécurité de vos informations personnelles. Nous affirmons sans équivoque que nous ne vendrons, ne louerons ni ne divulguerons autrement vos informations personnelles à des tiers sans obtenir votre consentement explicite et éclairé. Notre engagement envers votre confidentialité comprend l'utilisation de protocoles de cryptage avancés, la mise en œuvre de pratiques de stockage des données sécurisées et la surveillance continue et l'amélioration de nos mesures de sécurité pour atténuer les risques potentiels. Nous reconnaissons la sensibilité des informations que vous nous confiez et sommes fermement engagés à les traiter avec le plus grand soin et diligence. S'il y a des modifications proposées à nos pratiques de protection des données, nous vous en informerons rapidement, en sollicitant votre consentement lorsque requis par les lois et réglementations applicables. Pour une compréhension complète de nos politiques de protection des données, veuillez vous référer à notre Politique de Confidentialité, qui décrit en détail comment nous collectons, traitons et protégeons vos informations personnelles.",
    "EIGHTH": "Limitation de responsabilité",
    "EIGHTHDESCRIPTION": "DSS ne pourra être tenu responsable des dommages, y compris, mais sans s'y limiter, la perte de profits, la perte de données ou l'interruption d'activité découlant de l'utilisation ou de l'incapacité à utiliser DSS. Les utilisateurs reconnaissent que DSS est fourni tel quel et que, bien que des efforts diligents soient déployés pour garantir sa fonctionnalité et sa fiabilité, des circonstances imprévues ou des problèmes techniques peuvent survenir. En aucun cas DSS, ses filiales ou ses concédants de licence ne pourront être tenus responsables des dommages directs, indirects, accessoires, spéciaux ou consécutifs, qu'ils soient fondés sur une garantie, un contrat, un délit ou toute autre théorie légale, découlant de l'utilisation ou de la performance de DSS. Les utilisateurs sont encouragés à sauvegarder régulièrement des données critiques et à évaluer la compatibilité de DSS avec leurs exigences spécifiques. DSS décline toute garantie ou déclaration concernant l'exactitude, l'exhaustivité ou la fiabilité du logiciel. En utilisant DSS, les utilisateurs acceptent et reconnaissent cette limitation de responsabilité, et il est recommandé de revoir ces termes périodiquement pour en prendre connaissance et les comprendre.",
    "NINTH": "Droit applicable",
    "NINTHDESCRIPTION": "Ces termes et conditions seront régis et interprétés conformément aux lois applicables de la juridiction où l'utilisateur est situé ou, si non spécifié, conformément aux lois choisies par les parties pour régir l'utilisation de cette solution de signature électronique appelée DSS. Les parties conviennent par la présente de se soumettre à la juridiction exclusive des tribunaux compétents de la juridiction concernée pour la résolution de tout litige découlant de ou en relation avec ces termes et conditions.",
    "TENTH": "Accord complet",
    "TENTHDESCRIPTION": "Ces termes et conditions constituent l'intégralité de l'accord entre vous et DSS et remplacent tous les accords et entendements antérieurs entre les parties.",
    "ELEVENTH": "Paiements d'abonnement et remboursements",
    "ELEVENTHDESCRIPTION": "En effectuant un paiement d'abonnement pour DSS, vous reconnaissez et acceptez que les frais d'abonnement ne sont pas remboursables. Aucun remboursement ne sera accordé avant la fin de la durée de l'abonnement. Il est de votre responsabilité d'évaluer et de garantir la compatibilité de DSS avec vos exigences avant de vous engager dans un abonnement. Si vous avez des questions ou des préoccupations concernant les termes de l'abonnement, veuillez nous contacter à [Vos coordonnées] avant d'effectuer un paiement. Divisibilité Si une disposition de ces termes et conditions est jugée inapplicable, cette disposition sera supprimée de ces termes et conditions et les dispositions restantes resteront en vigueur.",
    "TWELFTH": "Aucune renonciation à une disposition",
    "TWELFTHDESCRIPTION": "dans ces termes et conditions ne sera valide à moins qu'elle ne soit documentée par écrit et dûment signée par les deux parties pour être considérée comme effective.",
    "THIRTEEN": "Informations de contact",
    "THIRTEENDESCRIPTION": "Si vous avez des questions sur ces termes et conditions, veuillez nous contacter à [Vos coordonnées].",
    "AGREE_TERMS_AND_CONDITIONS": "En cochant, vous confirmez que vous avez lu, compris et accepté les termes et conditions de DSS.",
    "PROCEED": "Confirmer et procéder"
  },
  "FORM_BUILDER": {
    "NAME": "Créateur de formulaires",
    "NEW_FORM": "Nouveau formulaire",
    "SIGNER": "Signataire",
    "TEXTAREA": "Zone de texte",
    "FORM_ELEMENTS": "Éléments du formulaire",
    "PRIMARY_SIGNER": "Signataire principal",
    "GROUP_TITLE": "Titre du groupe"
  },
  "facebook": "Continuer avec Facebook",
  "NO-RESULTS": "Aucun résultat trouvé",
  "NO-RESULTS-DESCRIPTION": "Aucun résultat ne correspond à votre recherche. Essayez d'ajuster vos termes de recherche ou de supprimer les filtres actifs.",
  "NO-ORDERS": "Aucune commande de signature pour le moment",
  "NO-ORDERS-DESCRIPTION": "Créez votre première commande de signature pour commencer. Partagez des documents avec les destinataires et suivez leur progression de signature.",
  "CONTRACT_SIGNED": "Contrat signé avec succès",
  "CONTRACT_REVIEWED": "Contrat examiné avec succès",
  "SERVICE_IN_MAINTENANCE": "Service en maintenance",
  "SIGNING_HEADER": {
    "SIGNATURE_REQUESTED": "Signature demandée"
  },
  "SIGNING_PARTICIPANT": {
    "DELETE_RECIPIENT_TITLE": "Supprimer le destinataire",
    "DELETE_RECEIVER_TITLE": "Supprimer le destinataire en copie",
    "REMOVE_RECIPIENT": "Supprimer le destinataire",
    "REMOVE_RECEIVER": "Supprimer le destinataire en copie",
    "DELETE_RECIPIENT_DESCRIPTION": "Cela supprimera définitivement le destinataire de l’ordre de signature. Tous les champs qui lui sont attribués ne seront plus attribués.",
    "DELETE_RECEIVER_DESCRIPTION": "Cela supprimera définitivement le destinataire en copie de l’ordre de signature. Tous les champs qui lui sont attribués ne seront plus attribués.",
    "SEND_REMINDER_TITLE": "Envoyer un rappel",
    "SEND_REMINDER_SUBTITLE": "Sélectionnez les destinataires à notifier",
    "SELECTED_COUNT": "{{count}} sélectionné(s)",
    "DELETE_SUBTITLE": "Cette action est irréversible."
  },
  "DOCUMENT_PREVIEW": {
    "DECLINE_ORDER_TITLE": "Refuser l’ordre de signature",
    "DECLINE_ORDER_SUBTITLE": "Cette action est irréversible.",
    "DECLINE_ORDER_CONFIRM": "Oui, je suis sûr",
    "DECLINE_MODAL_TITLE": "Rejeter cette demande",
    "DECLINE_MODAL_SUBTITLE": "Cette action ne peut pas être annulée",
    "DECLINE_MODAL_CANCEL": "Annuler",
    "DECLINE_MODAL_CONFIRM": "Rejeter la demande",
    "DECLINE_CONFIRMATION": "Êtes-vous sûr de vouloir rejeter cette demande de signature ? Cela informera tous les signataires et annulera définitivement la demande.",
    "DECLINE": "Rejeter la demande",
    "APPROVE": "Approuver/Signer la commande",
    "REVIEWED": "Marquer la commande comme examinée",
    "REFRESH": "Rafraîchir la page",
    "SOMETHING_WENT_WRONG": "Quelque chose s'est mal passé. Veuillez réessayer plus tard !",
    "NOT_FOUND": "Impossible d'obtenir votre document, veuillez contacter le support",
    "SUPPORT": "Votre navigateur Web ne prend pas en charge le rendu de fichiers",
    "DOWNLOAD": "Télécharger le fichier",
    "CONFIRMATION_MESSAGE": "Je confirme que j'ai lu et compris tous les documents.",
    "MODAL_CONFIRMATION_MESSAGE": "Veuillez confirmer que vous avez lu et compris tous les documents fournis",
    "USER_AGREEMENT": "Contrat d'utilisateur",
    "AGREE_SIGN": "Accepter & Signer",
    "INVALID_EMAIL": "Ce document est assigné à une adresse e-mail différente",
    "WRONG_EMAIL_EXPLANATION": "Vous êtes connecté avec une adresse e-mail qui ne correspond pas au destinataire invité à signer ce document.",
    "HIDE_MY_EMAIL_NOT_ALLOWED": "E-mail masqué détecté - L'e-mail masqué d'Apple n'est pas accepté. Cliquez pour <a href=\"https://support.apple.com/en-eg/guide/icloud/mm3adb030cbf/icloud\" target=\"_blank\" class=\"underline\">plus d'infos</a>",
    "STEP_VERIFY": "Vérifier",
    "STEP_REVIEW": "Réviser",
    "STEP_SIGN": "Signer",
    "STEP_DONE": "Terminé",
    "REVIEW_TITLE": "Révisez vos documents",
    "REVIEW_SUBTITLE": "Lisez attentivement tous les documents avant de procéder à la signature. Vous devez reconnaître les avoir examinés.",
    "REQUEST_DETAILS_LABEL": "Détails de la demande",
    "YOU": "vous",
    "SIGNER_LABEL": "Signataire",
    "SENDER_LABEL": "Expéditeur",
    "ORGANIZATION_LABEL": "Organisation",
    "EXPIRES_LABEL": "Expire le",
    "DOCUMENTS_LABEL": "Documents à signer",
    "PREVIEW_BUTTON": "Aperçu",
    "INFO_NOTE": "Veuillez examiner tous les documents joints dans leur intégralité. En signant, vous confirmez que vous avez lu, compris et accepté tous les termes qui y sont définis.",
    "CONTINUE_TO_SIGN": "Continuer pour signer",
    "SCROLL_TO_UNLOCK": "Prévisualisez tous les documents pour continuer",
    "PAGE_COUNT": "{{count}} pages",
    "LOADING_DOCUMENT": "Chargement du document..."
  },
  "SIGN_IN": {
    "MESSAGE": "Se connecter à DSS",
    "HEADING": "Collaboration de contrat pour chaque étape du cycle de vie",
    "SOMETHING_WENT_WRONG": "Quelque chose s'est mal passé. Veuillez réessayer plus tard !",
    "LOGOUT_AND_RETRY": "Réessayer",
    "SIGN_HEADING": "Signez votre commande",
    "SIGN_SUBHEADING": "Vérifiez votre identité pour consulter et signer la commande qui vous a été envoyée.",
    "CONTINUE_WITH": "Continuer avec {{provider}}",
    "METHOD_GOOGLE_DESCRIPTION": "Connectez-vous avec votre compte Google",
    "METHOD_APPLE_DESCRIPTION": "Connectez-vous avec votre identifiant Apple",
    "METHOD_LINKEDIN_DESCRIPTION": "Connectez-vous avec votre compte LinkedIn",
    "METHOD_DOODLE_DESCRIPTION": "Recevoir un code unique par e-mail",
    "METHOD_TYPED_DESCRIPTION": "Saisissez votre nom. Choisissez un style."
  },
  "ORDER_RECEIPT": {
    "ORDER_DECLINED": "Commande refusée",
    "ORDER_DECLINED_SUCCESSFULLY": "Vous avez refusé la commande. Vous pouvez fermer cette fenêtre",
    "ORDER_DECLINED_FAILED": "Échec du refus de la commande",
    "SIGNED_SUCCESSFULLY": "Commande signée avec succès",
    "REVIEWED_SUCCESSFULLY": "Commande examinée avec succès",
    "SIGNER_NAME": "Nom du signataire",
    "REVIEWER_NAME": "Nom de l'examinateur",
    "ORDER_ID": "ID de la commande #",
    "SIGNED_BY": "Signé par",
    "REVIEWED_BY": "Examiné par",
    "SIGNED_ON": "Signé le",
    "REVIEWED_ON": "Examiné le",
    "HELP": "Nous sommes là pour vous aider ! Pour toute question ou assistance, contactez-nous à",
    "SIGNATURE_REQUESTED": "Signature demandée",
    "SIGNING_REJECTED": "Signature refusée",
    "ORDER_SIGNED": "Commande signée !",
    "ORDER_REVIEWED": "Commande examinée !",
    "ORDER_REJECTED": "Commande refusée !",
    "ORDER_SIGNED_SUBTITLE": "Votre signature a été enregistrée et est juridiquement contraignante.",
    "ORDER_REVIEWED_SUBTITLE": "Votre examen a été enregistré et est juridiquement contraignant.",
    "ORDER_DECLINED_SUBTITLE": "Vous avez refusé cette demande de signature.",
    "ORDER_DECLINED_BY_RECIPIENT_SUBTITLE": "Cet ordre a été refusé par l'un des destinataires.",
    "CARD_TITLE_SIGNED": "Commande signée",
    "CARD_TITLE_REVIEWED": "Commande examinée",
    "CARD_TITLE_REJECTED": "Commande refusée",
    "STATUS_SIGNED": "Signé",
    "STATUS_REVIEWED": "Examiné",
    "STATUS_REJECTED": "Refusé",
    "STATUS_PENDING": "En attente",
    "REJECTED_ON": "Refusé le",
    "ALL_RECIPIENT_STATUS": "Statut de tous les destinataires",
    "YOU": "Vous",
    "EMAIL_PENDING_NOTE": "Vous recevrez un e-mail avec la copie signée une fois que tous les destinataires en attente auront terminé.",
    "ORDER_CANCELLED": "Commande annulée !",
    "ORDER_CANCELLED_SUBTITLE": "Cette commande a été annulée par l'expéditeur.",
    "ORDER_CANCELLED_BADGE": "Commande annulée",
    "CANCELLED_ON": "Annulé le",
    "ORDER_EXPIRED": "Commande expirée !",
    "ORDER_EXPIRED_SUBTITLE": "Cette commande a expiré et n'accepte plus de signatures.",
    "ORDER_EXPIRED_BADGE": "Commande expirée",
    "EXPIRED_ON": "Expiré le",
    "ORDER_PENDING": "Signature en attente",
    "ORDER_PENDING_SUBTITLE": "Cette commande attend votre action.",
    "REQUESTED_ON": "Demandé le"
  },
  "404": {
    "MESSAGE": "Oups ! Page disparue dans l'inconnu numérique",
    "DESCRIPTION": "La page que vous recherchez a peut-être été supprimée, son nom a changé ou est temporairement indisponible."
  },
  "ORDER_NOT_FOUND": {
    "MESSAGE": "Commande non trouvée : La trace numérique mène à un panier vide",
    "DESCRIPTION": "La commande que vous avez demandée n'existe pas. Elle a peut-être été supprimée ou expirée. Veuillez vérifier les détails de la commande et réessayer"
  },
  "DRAW_SIGNATURE": {
    "MESSAGE": "Dessinez votre signature ci-dessous",
    "CLEAR": "Effacer",
    "NEED_DRAW": "Vous devez dessiner une signature",
    "SIGN_DOCUMENT": "Signer le document",
    "TITLE": "Dessinez votre signature",
    "SUBTITLE": "Signez dans le cadre ci-dessous avec votre souris ou votre doigt. Cela sera appliqué à tous les documents de cette demande.",
    "CANVAS_LABEL": "Signez ici",
    "CANVAS_PLACEHOLDER": "Signez avec votre doigt ou votre souris",
    "HINT": "Utilisez la souris ou le toucher pour dessiner",
    "APPLY_SUBMIT": "Appliquer la signature et soumettre",
    "BACK": "Retour",
    "REJECT_ORDER": "Rejeter la commande"
  },
  "TYPE_SIGNATURE": {
    "BACK": "Retour",
    "TITLE": "Saisir votre signature",
    "SUBTITLE": "Saisissez votre nom légal. JunoSign le mettra automatiquement en forme dans le style de signature professionnel de votre choix.",
    "LANGUAGE_LABEL": "Langue de la signature",
    "LANGUAGE_HINT": "Sélectionnez la langue de signature souhaitée.",
    "SCRIPT_LATIN": "Latin",
    "SCRIPT_ARABIC": "Arabe",
    "PREVIEW_LABEL": "Aperçu de la signature",
    "PREVIEW_HINT": "Prévisualisez l'apparence de votre signature professionnelle.",
    "STYLE_LABEL": "Style de signature",
    "STYLE_1": "Style 1",
    "STYLE_2": "Style 2",
    "STYLE_3": "Style 3",
    "STYLE_4": "Style 4",
    "LEGAL_NAME_LABEL": "Nom légal",
    "LEGAL_NAME_PLACEHOLDER": "Saisissez votre nom légal complet",
    "PREVIEW_PLACEHOLDER_LATIN": "Votre signature",
    "PREVIEW_PLACEHOLDER_ARABIC": "توقيعك",
    "APPLY_SUBMIT": "Appliquer la signature et envoyer",
    "REJECT_ORDER": "Refuser la commande",
    "ERRORS": {
      "MAX_LENGTH": "Le nom doit comporter 15 caractères maximum",
      "LATIN_ONLY": "Utilisez uniquement des lettres latines, ou passez la langue de signature à l'arabe",
      "ARABIC_ONLY": "Utilisez uniquement des lettres arabes, ou passez la langue de signature au latin"
    }
  },
  "CONFIRM_SIGNATURE": {
    "BACK": "Retour",
    "TITLE": "Confirmez votre signature",
    "SUBTITLE": "Vérifiez votre identité confirmée ci-dessous. Elle sera appliquée à tous les documents de cette demande.",
    "YOUR_DIGITAL_SIGNATURE": "Votre signature numérique",
    "INFO_NOTE": "En appliquant votre signature, vous confirmez avoir lu, compris et accepté toutes les conditions énoncées dans les documents.",
    "APPLY_SUBMIT": "Appliquer la signature et soumettre",
    "SUBMIT_REVIEW": "Marquer la commande comme examinée",
    "REJECT_ORDER": "Rejeter la commande",
    "SIGN_FAILED": "Échec de la signature de la commande. Veuillez réessayer."
  },
  "USER_ROLES": {
    "VIEWER": "Spectateur",
    "USER": "Utilisateur",
    "TEAM_LEAD": "Chef d'équipe",
    "ADMIN": "Administrateur",
    "OWNER": "Propriétaire"
  },
  "REMINDER_INTERVAL": {
    "NEVER": "Jamais",
    "DAILY": "Quotidien",
    "TWICEAWEEK": "Deux fois par semaine",
    "WEEKLY": "Hebdomadaire",
    "ADAYBEFOREEXPIRATION": "Un jour avant l'expiration"
  },
  "VERIFICATION_METHOD": {
    "EMAIL": "E-mail",
    "WHATSAPP_AND_EMAIL": "Whatsapp/E-mail",
    "WHATSAPP": "Whatsapp"
  },
  "FLOATING_DOC_LAYOUT": {
    "DOC_1_TITLE": "Contrat de service",
    "DOC_1_META": "Réf · 24-A8F",
    "DOC_1_STATUS": "Signé en 47s",
    "DOC_2_TITLE": "Conditions de coopération — Société privée",
    "DOC_2_META": "Page 2 sur 2 · 1 champ de signature",
    "DOC_3_TITLE": "NDA — Société privée",
    "DOC_3_META": "Confidentiel",
    "SIGN_HERE": "Signez ici",
    "BADGE_TEXT": "Signature demandée"
  },
  "SNACKBAR": {
    "SUCCESS": "Succès",
    "ERROR": "Erreur",
    "INFO": "Information",
    "WARNING": "Avertissement",
    "AND_MORE": "et {{ count }} de plus"
  },
  "TABLE": {
    "NO_DATA": "Aucune donnée à afficher",
    "ACTIONS": "Actions de la ligne",
    "SELECT_PAGE": "Sélectionner toutes les lignes de cette page",
    "SELECT_ROW": "Sélectionner la ligne",
    "EXPAND_ROW": "Développer la ligne",
    "COLLAPSE_ROW": "Réduire la ligne"
  }
}
